// element按需引入
import {
  Menu,
  MenuItem,
  Card,
  Input,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Row,
  Col,
  Divider,
  Pagination,
  Image,
} from "element-ui";
const element = {
  install: function (Vue) {
    Vue.use(Menu);
    Vue.use(MenuItem);
    Vue.use(Card);
    Vue.use(Input);
    Vue.use(Button);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Divider);
    Vue.use(Pagination);
    Vue.use(Image);
  },
};
export default element;
